import { ArticleParagraph2, Image, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { IOfferRowProps } from '../../../types';
import { DeactivatedLabel, Price } from '../../commonComponents';
import { WalkWayMinutes } from '../../commonComponents/WalkWayMinutes';

export const WideOfferRow = React.forwardRef<HTMLDivElement, IOfferRowProps>(
  ({ onClick, selectable, data, isActive, isViewed, testId, hideButton }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(
          styles['item'],
          selectable && styles['selectable'],
          isActive && styles['active'],
          isViewed && styles['viewed'],
        )}
        onClick={onClick}
        data-testid={testId}
      >
        <div className={cx(styles['cell'], styles['main'])}>
          <div className={styles['photo']}>
            <Image
              src={data.previewPhoto || ''}
              width={128}
              height={78}
              display="block"
              alt=""
              preloader
              objectFit="cover"
            />
          </div>
          <div className={styles['main-info']} data-name="WideOfferMainInfo">
            <UIHeading4 color="text-main-default">{data.title}</UIHeading4>
            {data.walkWayMinutes && <WalkWayMinutes>{data.walkWayMinutes}</WalkWayMinutes>}
            {data.deactivatedTitle && (
              <div className={styles['deactivated-label']}>
                <DeactivatedLabel title={data.deactivatedTitle} />
              </div>
            )}

            {hideButton && <div className={styles['hide-button']}>{hideButton}</div>}
          </div>
        </div>
        <div className={styles['cell']}>
          <Price diff={data.prices.priceDiff} subprice={data.prices.priceSqm}>
            {data.prices.price}
          </Price>

          <ArticleParagraph2 color="gray60_100">{data.prices.deposit}</ArticleParagraph2>
          <ArticleParagraph2 color="gray60_100">{data.prices.agentBonusPayment}</ArticleParagraph2>
        </div>
        <div className={cx(styles['cell'], styles['l'])}>
          <UIText1>{data.exposition}</UIText1>
        </div>
        <div className={styles['cell']}>
          <UIText1>{data.dateStart}</UIText1>
          <div className={styles['xs']}>
            <UIText2 color="gray60_100">{data.expositionFull}</UIText2>
          </div>
        </div>
        <div className={styles['cell']}>
          <UIText1>{data.dateEnd}</UIText1>
        </div>
      </div>
    );
  },
);

WideOfferRow.displayName = 'WideOfferRow';
